import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { problems } from '../data/content';

const { FiFileText, FiAlertTriangle, FiTrendingUp } = FiIcons;
const icons = [FiFileText, FiAlertTriangle, FiTrendingUp];

// Problem-/Schmerzpunkt-Sektion
function Problems() {
  return (
    <section id="vorteile" className="bg-[#111827] py-16 text-white">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="max-w-2xl text-3xl font-extrabold">Warum viele beim Auswandern Zeit und Geld verlieren</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {problems.map((p, i) => (
            <article key={p.title} className="rounded-2xl border border-white/10 bg-white/5 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#D52B1E] text-xl">
                <SafeIcon icon={icons[i]} aria-hidden="true" />
              </span>
              <h3 className="mt-4 text-xl font-bold">{p.title}</h3>
              <p className="mt-2 text-gray-300">{p.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Problems;